import { Navigate, useParams } from "react-router-dom";
import { useCanAccessCareerOverview } from "./_hooks/useCanAccessCareerOverview";

export default function CareerIndex() {
  const { pgaId } = useParams();
  const showOverview = useCanAccessCareerOverview();

  if (!pgaId) return null;

  return (
    <Navigate to={showOverview ? `/people/${pgaId}/career/overview` : `/people/${pgaId}/career/employment`} replace />
  );
}
